<template>
  <div>
    <div
      id="claimModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="claimModal"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content">
          <div class="card card-alert text-dark bg-primary o-hidden h-100">
            <div class="card-body">
              <h5>{{ $t('lang.claim.claim_modal_title') }}</h5>
            </div>
            <div class="card-footer bg-white text-center">
              <button
                type="button"
                class="btn btn-outline-dark"
                data-dismiss="modal"
                data-toggle="modal"
                data-target="#newClaimModal"
              >
                {{ $t('lang.claim.start_claim') }}
              </button>
              <button
                type="button"
                class="btn btn-outline-primary"
                data-dismiss="modal"
                @click="$emit('toHelpCenter')"
              >
                {{ $t('lang.claim.help_center') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      id="newClaimModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="newClaimModal"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content">
          <div class="card card-alert text-dark bg-primary o-hidden h-100">
            <div class="card-header">
              <h5>{{ $t('lang.claim.new_claim_modal_title') }}</h5>
            </div>

            <div
              v-if="!successMessage"
              class="card-body bg-white"
            >
              <Errors :errors="errors" />

              <form @submit.prevent="formSubmit">
                <div class="form-group">
                  <label>{{ $t('lang.claim.claim_type_title') }}</label>
                  <select
                    v-model="formData.subject"
                    name="claim_subjects"
                    class="form-control"
                    required
                  >
                    <option value="payment_issue">
                      {{ $t('lang.claim.claim_type.payment_issue') }}
                    </option>
                    <option value="store_issue">
                      {{ $t('lang.claim.claim_type.store_issue') }}
                    </option>
                    <option value="bag_issue">
                      {{ $t('lang.claim.claim_type.bag_issue') }}
                    </option>
                    <option value="steal_issue">
                      {{ $t('lang.claim.claim_type.steal_issue') }}
                    </option>
                    <option
                      value="other"
                      selected
                    >
                      {{ $t('lang.claim.claim_type.other') }}
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label>{{ $t('lang.claim.new_claim_text') }}</label>
                  <textarea
                    v-model="formData.description"
                    class="form-control"
                    rows="5"
                    maxlength="1000"
                    required
                  />
                </div>
              </form>
            </div>

            <div
              v-if="!successMessage"
              class="card-footer bg-white text-center"
            >
              <button
                v-if="!validated"
                type="button"
                class="btn btn-outline-dark"
                data-dismiss="modal"
              >
                {{ $t('lang.forms.cancel') }}
              </button>
              <button
                type="submit"
                class="btn btn-outline-primary"
                :disabled="validated"
                @click="formSubmit"
              >
                <span v-if="validated"><i
                  class="icon-spin6 animate-spin"
                  style="font-size: 130%"
                /></span>
                <span v-else>{{ $t('lang.forms.send') }}</span>
              </button>
            </div>

            <div
              v-if="successMessage"
              class="card-body bg-white"
            >
              <Success :success-message="successMessage" />
              <p style="margin-bottom: 0; color: #999;">
                {{ $t('lang.claim.claim_success2') }}
              </p>
            </div>

            <div
              v-if="successMessage"
              class="card-footer bg-white text-center"
            >
              <button
                type="button"
                class="btn btn-outline-primary"
                @click="reloadPage()"
              >
                {{ $t('lang.forms.back') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API, errorResponse } from '../../api/api';

import Errors from '../Alerts/Errors';
import Success from '../Alerts/Success';

const ClaimAPI = API.get('claim');

export default {
  name: 'StartClaim',

  components: {
    Errors,
    Success,
  },
  props: {
    bookingId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      formData: {
        subject: null,
        description: null,
      },
      successMessage: null,
      errors: {},
      validated: false,
    };
  },

  methods: {
    async formSubmit(e) {
      e.preventDefault();
      this.errors = {};

      if (this.formData.subject && this.formData.description) {
        this.validated = true;
        try {
          const { data } = await ClaimAPI.newClaim({
            booking_id: this.bookingId,
            subject: this.formData.subject,
            description: this.formData.description,
          });
          if (data) {
            this.successMessage = this.$t('lang.claim.claim_success');
          }
        } catch (error) {
          this.errors = errorResponse(error);
        }

        window.scrollTo(0, 0);
      } else {
        this.errors = { internal_error: [this.$t('lang.forms.complete')] };
      }
      this.validated = false;
    },

    reloadPage() {
      // Reload page forced
      window.location.href = `${this.$router.currentRoute.path}?claim=success`;
    },
  },
};
</script>

<style scoped>

</style>
